"use client";
import t, { useState as u, useId as d } from "react";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es18.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import f from "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import "./index.es33.js";
import "./index.es34.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es37.js";
import "./index.es38.js";
import "./index.es52.js";
import "./index.es53.js";
import "./index.es54.js";
import "./index.es55.js";
import "./index.es56.js";
import "./index.es57.js";
import "./index.es58.js";
import k from "./index.es59.js";
import h from "styled-components";
const E = h.div`
  text-align: right;
`, g = ({
  content: o,
  title: r,
  tooltips: n,
  keyContext: i,
  isOpen: l,
  onChange: p
}) => {
  const a = d(), e = () => {
    p(!l);
  };
  return /* @__PURE__ */ t.createElement(
    k,
    {
      onClick: e,
      isOpen: l,
      header: r,
      contentId: a
    },
    /* @__PURE__ */ t.createElement(
      f,
      {
        keyContext: `${i}-content`,
        className: "bl-p-b-3",
        content: o,
        tooltips: n
      }
    )
  );
}, Y = ({
  keyContext: o,
  accordions: r
}) => {
  const [n, i] = u(
    /* @__PURE__ */ new Set()
  ), l = n.size >= r.length, p = l ? "Lukk Alle" : "Åpne Alle", a = (e) => {
    e.preventDefault(), i(l ? /* @__PURE__ */ new Set() : new Set(r.map((m) => m.id)));
  };
  return r && Array.isArray(r) ? /* @__PURE__ */ t.createElement(t.Fragment, null, r.length > 1 && /* @__PURE__ */ t.createElement(E, null, /* @__PURE__ */ t.createElement("a", { href: "#", onClick: a, className: "bl-link bl-m-y-2" }, p)), /* @__PURE__ */ t.createElement("ul", null, /* @__PURE__ */ t.createElement("li", null, r.map((e) => {
    const m = `${o}-accordion-${e.id}`, c = (s) => {
      s ? n.add(e.id) : n.delete(e.id), i(new Set(n));
    };
    return /* @__PURE__ */ t.createElement(
      g,
      {
        ...e,
        keyContext: m,
        key: m,
        isOpen: n.has(e.id),
        onChange: c
      }
    );
  })))) : /* @__PURE__ */ t.createElement(t.Fragment, null);
};
export {
  Y as default
};
//# sourceMappingURL=index.es39.js.map
